// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/require-object-coercible.js